
export function getLocalStorageItem(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw || raw === "undefined") return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setLocalStorageItem(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch {

  }
}


export function removeLocalStorageItem(key) {
  try {
    localStorage.removeItem(key);
  } catch {

  }
}
